(function () {
  'use strict';

  var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'srsltid', 'msclkid'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term'];
  var STORAGE_KEY = 'rlc_attribution_v1';
  var GA4_DESTINATION = 'G-LNRL32VG7F';
  var ADS_HANDOFF_DESTINATION = 'AW-18188403191/8KexCNfomMkcEPeD9OBD';
  var handoffSent = false;

  function getPageKey() {
    var pageRoot = document.querySelector('[data-rlc-page]');
    var declaredKey = pageRoot && pageRoot.getAttribute('data-rlc-page');
    if (declaredKey) return declaredKey.slice(0, 80);

    var slug = window.location.pathname.split('/').filter(Boolean).pop() || 'home';
    if (slug === 'best-red-light-therapy-mats-2026' || slug === 'home') return 'mat-review';
    return slug.replace(/^red-light-therapy-for-/, '').slice(0, 80) || 'mat-review';
  }

  function getPageType(pageKey) {
    return pageKey === 'mat-review' ? 'mat_review' : 'pain_advice';
  }

  function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  }

  function readStored() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (error) {
      return {};
    }
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var stored = readStored();
    CLICK_KEYS.concat(UTM_KEYS).forEach(function (key) {
      var value = params.get(key);
      if (value) stored[key] = value.slice(0, 500);
    });
    stored.landing_page = stored.landing_page || window.location.pathname;
    stored.captured_at = stored.captured_at || new Date().toISOString();
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (error) {}
    return stored;
  }

  function decorateLink(link, attribution, pageKey) {
    try {
      var target = new URL(link.href, window.location.origin);
      if (target.hostname !== 'luscentred.com' && target.hostname !== 'www.luscentred.com') return;

      var hasGoogleClickId = attribution.gclid || attribution.gbraid || attribution.wbraid;
      if (hasGoogleClickId) {
        UTM_KEYS.forEach(function (key) { target.searchParams.delete(key); });
      }

      CLICK_KEYS.forEach(function (key) {
        if (attribution[key]) target.searchParams.set(key, attribution[key]);
      });
      target.searchParams.set('rlc_page', pageKey);
      link.href = target.toString();
      link.dataset.rlcDecorated = '1';
    } catch (error) {}
  }

  function decorateAll(attribution, pageKey) {
    document.querySelectorAll('a[href*="luscentred.com"]').forEach(function (link) {
      decorateLink(link, attribution, pageKey);
    });
  }

  var attribution = captureAttribution();
  var pageKey = getPageKey();
  var pageType = getPageType(pageKey);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'rlc_advertorial_view',
    page_type: pageType,
    rlc_page: pageKey,
    page_path: window.location.pathname,
    original_landing_page: attribution.landing_page || window.location.pathname
  });
  ensureGtag();
  window.gtag('event', 'rlc_advertorial_view', {
    send_to: GA4_DESTINATION,
    page_type: pageType,
    rlc_page: pageKey,
    page_path: window.location.pathname,
    original_landing_page: attribution.landing_page || window.location.pathname
  });

  function initialize() {
    decorateAll(attribution, pageKey);
    try {
      if (window.clarity) window.clarity('set', 'rlc_page', pageKey);
    } catch (error) {}
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href*="luscentred.com"]') : null;
      if (!link) return;
      decorateLink(link, attribution, pageKey);
      if (handoffSent) return;
      handoffSent = true;
      var handoffPayload = {
        click_url: link.href,
        link_position: link.dataset.linkPosition || 'unspecified',
        link_text: (link.textContent || '').trim().slice(0, 80),
        rlc_page: pageKey,
        page_path: window.location.pathname
      };
      window.dataLayer.push({
        event: 'rlc_mat_handoff',
        click_url: handoffPayload.click_url,
        link_position: handoffPayload.link_position,
        link_text: handoffPayload.link_text,
        rlc_page: handoffPayload.rlc_page,
        page_path: handoffPayload.page_path
      });
      ensureGtag();
      window.gtag('event', 'rlc_mat_handoff', {
        send_to: GA4_DESTINATION,
        click_url: handoffPayload.click_url,
        link_position: handoffPayload.link_position,
        link_text: handoffPayload.link_text,
        rlc_page: handoffPayload.rlc_page,
        page_path: handoffPayload.page_path
      });
      window.gtag('event', 'conversion', {
        send_to: ADS_HANDOFF_DESTINATION,
        event_timeout: 2000,
        rlc_page: pageKey,
        link_position: handoffPayload.link_position
      });
      try {
        if (window.clarity) {
          window.clarity('set', 'rlc_page', pageKey);
          window.clarity('event', 'rlc_mat_handoff');
        }
      } catch (error) {}
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  window.setTimeout(function () { decorateAll(attribution, pageKey); }, 1500);
})();
